var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNorwegian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44939_319347)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44939_319347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0H-1.2v24h26.4V0z",
    fill: "#EF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 0H6v24h4.8V0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 9H-1.2v6h26.4V9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0H7.2v24h2.4V0z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 10.5H-1.2v3h26.4v-3z",
    fill: "#002868"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44939_319347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44939_319347"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-1.2)",
    d: "M0 0h26.4v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorwegian);
export default __webpack_public_path__ + "static/media/norwegian.2694343cb0a9cf53fd598a3228374162.svg";
export { ForwardRef as ReactComponent };